/* eslint-disable */
(function(i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function() {
    (i[r].q = i[r].q || []).push(arguments);
  };
  i[r].l = 1 * new Date;
  a = s.createElement(o);
  m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

function track() {
  ga('create', 'UA-54494315-5', 'auto');

  ga('require', 'linkid');

  // begin: remove secret params from parameters
  var paramsToRemove = [
    'confirmation_token',
    'phone_number_confirmation_token',
    'token',
    'reset_password_token'
  ];
  var page = location.href;

  for (var i = 0; i < paramsToRemove.length; i++) {
    page = removeParam(paramsToRemove[i], page);
  }
  ga('set', 'page', page);

  ga('send', 'pageview');

  // http://stackoverflow.com/questions/16941104/remove-a-parameter-to-the-url-with-javascript
  function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  }
}

if(window.meta && window.meta.environment == 'production') {
  track();
}
